import { render, staticRenderFns } from "./WorkExperience.vue?vue&type=template&id=bbb67440&scoped=true&"
var script = {}
import style0 from "./WorkExperience.vue?vue&type=style&index=0&id=bbb67440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb67440",
  null
  
)

export default component.exports